import React, { useContext, useMemo, useState } from "react";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import useAddedToBagModal from "@hooks/product-detail/use-added-to-bag-modal/";

const emptyObj = {};

const ProductDetailContext = React.createContext(emptyObj);

export const useProductDetailContext = () => useContext(ProductDetailContext);

const ProductDetailProvider = ({ children, showAddToBox }) => {
  const router = useRouter();
  const { editProductIds: editIds } = router.query;
  const editProductIds = useMemo(() => (!showAddToBox && editIds?.split(",")) || [], [editIds]);

  const { toggleAddedToBagModal, renderAddedToBagModal } = useAddedToBagModal();
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  const [isColorSelected, setIsColorSelected] = useState(false);
  const [optionSelectionError, setOptionSelectionError] = useState(false);
  const [colorSelectionError, setColorSelectionError] = useState(false);

  const productDetailContextValues = useMemo(() => {
    return {
      editProductIds,
      toggleAddedToBagModal,
      renderAddedToBagModal,
      isOptionSelected,
      optionSelectionError,
      setIsOptionSelected,
      setOptionSelectionError,
      isColorSelected,
      setIsColorSelected,
      colorSelectionError,
      setColorSelectionError,
    };
  }, [
    editProductIds,
    toggleAddedToBagModal,
    renderAddedToBagModal,
    isOptionSelected,
    optionSelectionError,
    setIsOptionSelected,
    setOptionSelectionError,
    isColorSelected,
    setIsColorSelected,
    colorSelectionError,
    setColorSelectionError,
  ]);

  return (
    <ProductDetailContext.Provider value={productDetailContextValues}>
      {children}
    </ProductDetailContext.Provider>
  );
};

export default ProductDetailProvider;
